module.exports = __webpack_public_path__ + "static/media/stopwatch.d7e975bb.svg";